<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3">
                <div class="mt-4 mt-lg-0">
                  <h4 class="card-title">Customer</h4>
                  <v-select
                    :options="customers"
                    label="customer"
                    v-model="searchCustomer"
                    @input="getJobs()"
                  ></v-select>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="mt-4 mt-lg-0">
                  <h4 class="card-title">Job #</h4>
                  <v-select
                    :options="jobs"
                    item-text="label"
                    item-value="value"
                    v-model="searchJobNum"
                  ></v-select>
                </div>
              </div>
              <div class="col-lg-3">
                <h4 class="card-title">Start Date</h4>
                <date-picker
                  v-model="searchStartDate"
                  :first-day-of-week="1"
                  lang="en"
                ></date-picker>
              </div>
              <div class="col-lg-3">
                <h4 class="card-title">End Date</h4>
                <date-picker
                  v-model="searchEndDate"
                  :first-day-of-week="1"
                  lang="en"
                ></date-picker>
              </div>
            </div>
            <!-- end row -->
            <div class="form-group row mt-4 d-flex justify-content-end align-items-end mr-2">
              <label class="mb-0 mr-2">Time Approval Status: </label>
              <div>
                <div class="d-flex" style="gap: 1rem;">
                  <b-form-radio
                    v-for="(type, typeIndex) in timeApprovalStatusFilters"
                    :key="typeIndex"
                    v-model="selectedTimeApprovalFilter"
                    :name="type.label"
                    :value="type.value"
                  >
                    {{ type.label }}
                  </b-form-radio>
                </div>
              </div>
            </div>
            <div class="row mt-3 float-right">
              <div class="col-12">
                <b-button
                  id="btn_search"
                  variant="primary"
                  :disabled="loading"
                  v-on:click="generateReport()"
                  style="min-width: 86.98px"
                  >
                  <spring-spinner
                    v-if="loading"
                    class="label-spinner mx-auto"
                    :animation-duration="3000"
                    :size="20"
                    color="white"
                  />
                  <span v-else>Generate</span>
                </b-button>
              </div>
            </div>
            <div class="row mt-3 mr-3 float-right">
              <div class="col-12">
                <ReportsPDF
                  :tableData="tableData"
                  :summaryReport="summaryTableData"
                  :reportTotals="reportTotals"
                  :searchCustomer="searchCustomer"
                  :searchJobNum="searchJobNum? searchJobNum.value : null"                  
                  :searchStartDate="searchStartDate"
                  :searchEndDate="searchEndDate"
                  :searchEmployee="searchEmployee"
                ></ReportsPDF>
              </div>
            </div>
            <div class="row mt-3 mr-3 float-right">
              <div class="col-12">
                <ExportToExcel
                  :tableData="tableData"
                  :summaryTableData="summaryTableData"
                  :itemizedSummaryTableData="itemizedSummaryTableData"
                  :searchCustomer="searchCustomer"
                  :searchJobNum="searchJobNum? searchJobNum.value : null"
                  :searchStartDate="searchStartDate"
                  :searchEndDate="searchEndDate"
                  :exportType="'hours_worked'"
                ></ExportToExcel>
              </div>
            </div>

            <!-- en row -->
          </div>
        </div>
        <!-- end card -->
        <!-- Totals -->
        <div class="row">
          <div
            v-for="total of reportTotals"
            :key="total.index"
            class="col-md-4"
          >
            <Stat
              :icon="total.icon"
              :title="total.title"
              :value="total.value"
            />
          </div>
        </div>
        <!-- /Totals -->
        <!-- Table -->
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Times</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-compare="tableSort"
                :filter="filter"
                :filter-included-fields="filterOn"
                primary-key="id"
              >
                <template v-slot:cell(jobActions)="data">
                  <b-dropdown size="sm" variant="primary">
                    <template v-slot:button-content>
                      <i class="mdi mdi-chevron-down"></i>
                    </template>
                    <b-dropdown-item @click="updateJobCompleteStatus(data.item.JobDocID, data.item.JobCompletedStatus)">
                      <i class="bx mr-2 tableIcons" :class="!data.item.JobCompletedStatus ? 'bx-check' : 'bx-x'"></i>
                      {{!data.item.JobCompletedStatus ? 'Mark Job as Complete' : 'Mark Job as Incomplete'}}
                    </b-dropdown-item>
                    <b-dropdown-item @click="goToJob(data.item.JobNum)">
                      <i class="bx mr-2 tableIcons bx-log-in-circle"></i>
                      Go to Job
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
                <template v-slot:cell(approved)="data">
                  <div
                    :id="`hoursApproved-${data.item.id}`"
                    style="display: inline-block"
                  >
                    <b-form-checkbox v-model="data.item.approved" @change="(newValue) => approveTime(newValue, data.item.id)">
                    </b-form-checkbox>
                  </div>
                  <b-tooltip
                    :target="`hoursApproved-${data.item.id}`"
                    triggers="hover"
                    v-if="data.item.approved && data.item.approvedBy"
                  >
                    {{
                      `Approved by ${
                        data.item.approvedBy.name
                      } on ${data.item.approvedTime
                        .toString()
                        .substring(0, 15)} at ${data.item.approvedTime
                        .toString()
                        .substring(16, 21)}`
                    }}
                  </b-tooltip>
                </template>
                <template v-slot:cell(JobNum)="data">
                  <router-link
                    :to="{
                      path: '/production/jobs/jobDetails/' + getJobNumFromString(data.item.JobNum),
                    }"
                  >
                    <span :class="data.item.JobCompletedStatus ? 'text-success' : ''">{{data.item.JobNum}}</span>
                  </router-link>
                </template>
                <template v-slot:cell(type)="data">
                  <b-badge :variant="data.value === 'ot'
                  ? 'danger'
                  : data.value === 'tt'
                  ? 'info'
                  : 'success'">{{
                    data.value === 'ot'
                      ? 'Overtime'
                      : data.value === 'tt'
                      ? 'Travel'
                      : 'Regular'
                  }}</b-badge>
                </template>
                <template v-slot:cell(billable)="data">
                  <b-badge :variant="data.value ? 'success' : 'danger'">{{
                    data.value ? 'Yes' : 'No'
                  }}</b-badge>
                </template>
                <!-- <template slot="FOOT_b">
                        1
                      </template> -->
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Table -->

        <!-- Summary Table -->

        <div class="card">
          <div class="card-body">
            <h4 class="card-title">All Employees Summary</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPageSummary"
                      size="sm"
                      :options="pageOptionsSummary"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filterSummary"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>

            <div class="table-responsive mb-0">
              <b-table
                :items="summaryTableData"
                :fields="fieldsSummary"
                responsive="sm"
                :per-page="perPageSummary"
                :current-page="currentPageSummary"
                :sort-by.sync="sortBySummary"
                :sort-desc.sync="sortDescSummary"
                :sort-compare="tableSort"
                :filter="filterSummary"
                :filter-included-fields="filterOnSummary"
              >
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPageSummary"
                      :total-rows="rowsSummary"
                      :per-page="perPageSummary"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Summary Table -->

        <!-- Chart -->
        <div class="row">
          <div class="col-6">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title mb-4">Hours Worked by Day</h4>
                <!-- Column Charts -->
                <apexchart
                  class="apex-charts"
                  height="350"
                  type="area"
                  dir="ltr"
                  id="hoursByDays"
                  :series="hoursByDays.series"
                  :options="hoursByDays.chartOptions"
                ></apexchart>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title mb-4">Time Worked by Employee</h4>
                <apexchart
                  width="500"
                  height="350"
                  type="donut"
                  :options="hoursByEmployee.chartOptions"
                  :series="hoursByEmployee.series"
                  :labels="hoursByEmployee.labels"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
        <!-- /Chart -->
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Vue from 'vue';
import Layout from '../../../layouts/main';
import PageHeader from '@/components/page-header';
import appConfig from '@/app.config';
import DatePicker from 'vue2-datepicker';
import routes from '../../../routes.js';
import Stat from '@/components/widgets/stat';
import ReportsPDF from '../components/reports/reportsPDF.vue';
import ExportToExcel from '../components/reports/ExportToExcel.vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import Swal from 'sweetalert2';
import lodash from 'lodash';
import { SpringSpinner } from 'epic-spinners';
Vue.use(VueToast);

import firebase from 'firebase';
import { getCustomers, getJobsFromCustomer } from '../helper/dbHelpers.js';
import moment from 'moment';
import { tableSort } from '../helper/helpers.js';

export default {
  page: {
    title: 'Hours Worked Report',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    Stat,
    ReportsPDF,
    ExportToExcel,
    SpringSpinner
  },
  data() {
    return {
      title: 'Hours Worked Report',
      name: 'hoursWorked',
      items: [
        {
          text: 'home',
          href: '/',
        },
        {
          text: 'hours worked',
          href: '/production/reports/hoursWorked',
          active: true,
        },
      ],
      routes: routes,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'date',
      sortDesc: false,
      fields: [
        { key: 'jobActions', sortable: false },
        { key: 'approved', sortable: true },
        { key: 'Date', sortable: true },
        { key: 'JobNum', label: 'Job #', sortable: true },
        { key: 'Customer', sortable: true },
        { key: 'Employee', sortable: true },
        { key: 'Description', sortable: true, class: 'jobDescription' },
        { key: 'Billable', sortable: true },
        { key: 'Hours', sortable: true },
        { key: 'Type', sortable: true },
        { key: 'Rate', sortable: true },
        { key: 'lineTotal', label: 'Line Total', sortable: true },
      ],

      totalRowsSummary: 1,
      currentPageSummary: 1,
      perPageSummary: 10,
      pageOptionsSummary: [10, 25, 50, 100],
      filterSummary: null,
      filterOnSummary: [],
      sortBySummary: 'name',
      sortDescSummary: false,
      fieldsSummary: [
        { key: 'name', sortable: true },
        {
          key: 'regularHours.value',
          // label: 'Regular Hours.value',
          label: 'Regular Hours',
          sortable: true,
        },
        {
          key: 'overtimeHours.value',
          label: 'Overtime Hours.value',
          // label: 'Overtime Hours',
          sortable: true,
        },
        {
          key: 'travelHours.value',
          label: 'Travel Hours.value',
          // label: 'Travel Hours',
          sortable: true,
        },
      ],

      customers: [],
      jobs: [],
      searchEmployee: null,
      searchCustomer: null,
      searchJobNum: [],
      searchStartDate: null,
      searchEndDate: null,
      tableData: [],
      reportTotals: [
        {
          icon: 'bx bx-timer',
          title: 'Hours Worked',
          value: '0',
        },
        {
          icon: 'bx bx-calendar',
          title: 'Days Worked',
          value: '0',
        },
        {
          icon: 'bx bx-abacus',
          title: 'Avg. Hours/Day',
          value: '0',
        },
      ],
      hoursByDays: {
        series: [
          {
            name: 'Hours Worked',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '45%',
              endingShape: 'rounded',
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['#556ee6'],
          },
          colors: ['#556ee6', '#556ee6', '#f46a6a'],
          xaxis: {
            categories: [],
          },
          yaxis: {
            title: {
              text: 'hours',
            },
          },
          grid: {
            borderColor: '#f1f1f1',
          },
          fill: {
            opacity: 0,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + ' hours worked';
              },
            },
          },
        },
      },
      hoursByEmployee: {
        series: [0],
        chartOptions: {
          chart: {
            type: 'donut',
          },
          dataLabels: {
            enabled: false,
          },
          labels: [],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  show: false,
                },
              },
            },
          ],
          legend: {
            position: 'right',
            offsetY: 0,
            height: 200,
          },
        },
      },
      summaryTableData: [],
      productsInTable: [],
      itemizedSummaryTableData: [],
      currentUser: this.$store.state.custom.currentUserData,
      altTableData: [],
      timeApprovalStatusFilters: [
        { label: 'All', value: 'all' },
        { label: 'Only Approved', value: 'approved' },
        { label: 'Only Unapproved', value: 'unapproved' }
      ],
      selectedTimeApprovalFilter: 'all',
      loading: false
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },
    rowsSummary() {
      return this.summaryTableData.length;
    },
  },
  watch: {
    perPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        let currentUserDataCopy = JSON.parse(JSON.stringify(this.currentUser));
        let oldCurrentUserPerPage = null;

        if (currentUserDataCopy.tablePageLengths) {
          if(currentUserDataCopy.tablePageLengths.perPage_hoursWorkedTimes){
            oldCurrentUserPerPage = currentUserDataCopy.tablePageLengths.perPage_hoursWorkedTimes;
          }
          currentUserDataCopy.tablePageLengths['perPage_hoursWorkedTimes'] =
            newVal;
        } else {
          currentUserDataCopy['tablePageLengths'] = {
            perPage_hoursWorkedTimes: newVal,
          };
        }

        // prevent a write after page render, only write to db when user manually changes page length setting
        if (
          oldCurrentUserPerPage !== newVal
        ) {
          firebase
            .firestore()
            .collection('employees')
            .doc(this.currentUser.auth)
            .update({
              tablePageLengths: currentUserDataCopy.tablePageLengths,
            });
        }
        this.currentUser = currentUserDataCopy;
        this.$store.dispatch('custom/updateUserData', currentUserDataCopy);
      }
    },
    perPageSummary(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentUser = this.$store.state.custom.currentUserData;
        let currentUserDataCopy = JSON.parse(JSON.stringify(this.currentUser));
        let oldCurrentUserPerPage = null;
        if (currentUserDataCopy.tablePageLengths) {
          if(currentUserDataCopy.tablePageLengths.perPage_hoursWorkedSummary){
            oldCurrentUserPerPage = currentUserDataCopy.tablePageLengths.perPage_hoursWorkedSummary;
          }
          currentUserDataCopy.tablePageLengths['perPage_hoursWorkedSummary'] =
            newVal;
        } else {
          currentUserDataCopy['tablePageLengths'] = {
            perPage_hoursWorkedSummary: newVal,
          };
        }

        // prevent a write after page render, only write to db when user manually changes page length setting
        if (
          oldCurrentUserPerPage !== newVal
        ) {
          firebase
            .firestore()
            .collection('employees')
            .doc(this.currentUser.auth)
            .update({
              tablePageLengths: currentUserDataCopy.tablePageLengths,
            });
        }
        this.currentUser = currentUserDataCopy;
        this.$store.dispatch('custom/updateUserData', currentUserDataCopy);
          }
    },

    async altTableData(newItems) {
      // go through tabledata when it is changed and get job description for each alttabledata item
      // then add jobDescription to each alttabledata item
      let array = [...newItems];
      let jobsMap = {};
      if (array.length > 0 && array.length !== undefined) {
        this.specificJob = [];

        for (let index = 0; index < array.length; index++) {
          let item = array[index];
          // limit db reads so it only gets unique Jobs by comparing to jobsMap
          if (jobsMap[item.JobNum] === undefined) {
            let query = firebase
              .firestore()
              .collection('jobs')
              .where('org', '==', sessionStorage.getItem('org'))
              .where('jobNum', '==', Number(item.JobNum));
            try {
              await query
                .get()
                .then((querySnapshot) => {
                  querySnapshot.forEach((doc) => {
                    // add job and job description to map
                    jobsMap[item.JobNum] = {
                      description: doc.data().description, 
                      jobCompletedStatus: doc.data().completed ?? false,
                      jobDocID: doc.id
                    };
                    // update tabledata
                    let timeItem = array[index];
                    timeItem.JobNum = timeItem.JobNum + ` - ${doc.data().description}`;
                    timeItem.JobCompletedStatus = doc.data().completed ?? false;
                    timeItem.JobDocID = doc.id;
                  });
                })
                .catch((err) => {
                  console.log(err);
                  Vue.$toast.open({
                    message: `Error getting specific job from database.`,
                    duration: 4000,
                    position: 'top-right',
                    dismissible: true,
                    type: 'error',
                  });
                });
            } catch (err) {
              console.log(err);
              Vue.$toast.open({
                message: `Error adding job descriptions to the time table`,
                duration: 4000,
                position: 'top-right',
                dismissible: true,
                type: 'error',
              });
            }
          } else {
            // job info for this table data item has already been pulled from db so find it in map and use it
            // update tabledata
            let jobData = jobsMap[item.JobNum];
            let timeItem = array[index];
            timeItem.JobNum = timeItem.JobNum + ` - ${jobData.description}`;
            timeItem.JobCompletedStatus = jobData.jobCompletedStatus;
            timeItem.JobDocID = jobData.jobDocID;
          }
        }
        // reset altTableData so it doesn't build up when user generates more than one report in one session
        this.altTableData = [];
      }
    },
  },
  methods: {
    approveTime: async function (value, id) {
      try {
        let db = firebase.firestore();
        let page = db.collection('times').doc(id);
        let user = JSON.parse(sessionStorage.authUser);
        let approvedTime = Date.now();

        let index = this.tableData.findIndex((data) => data.id === id);
        let newData = JSON.parse(JSON.stringify(this.tableData[index]));
        newData.approved = value;
        newData.approvedTime = value ? Date(approvedTime) : null;
        newData.approvedBy = value
          ? { name: user.displayName, uid: user.uid }
          : null;

        await page
          .update({
            approved: newData.approved,
            approvedTime: newData.approvedTime,
            approvedBy: newData.approvedBy,
          })
          .then(() => {
            this.tableData.splice(index, 1, newData);
            Vue.$toast.open({
              message: value
                ? 'Time approved successfully'
                : 'Time unapproved successfully',
              type: 'success',
              duration: 4000,
              position: 'top-right',
            });
          })
          .catch(() => {
            console.log(`Error changing time approval status.`);
            Swal.fire(
              'Error!',
              'An error was encountered when changing the times approval status',
              'error'
            );
          });
      } catch (error) {
        console.log(error);
        Swal.fire('Error!', 'An error was encountered', 'error');
      }
    },
    generateReport: async function () {
      //construct the query string.
      try {
        this.loading = true
        //in order the chart to auto render, we need to set the array, not just push data to it.
        let hoursWorkedData = [{ name: 'Hours Worked', data: [] }];
        let hoursWorkedDays = { categories: [] };
        let hoursWorkedEmployeeNames = [];
        let hoursWorkedEmployeeData = [];

        this.summaryTableData = [];
        this.productsInTable = [];
        this.fieldsSummary = [
          { key: 'name', sortable: true },
          { key: 'regularHours.value', label: 'Regular Hours', sortable: true },
          {
            key: 'overtimeHours.value',
            label: 'Overtime Hours',
            sortable: true,
          },
          { key: 'travelHours.value', label: 'Travel Hours', sortable: true },
        ];
        this.reportTotals[0].value = '0';
        this.reportTotals[1].value = '0';
        this.reportTotals[2].value = '0';
        this.tableData = [];
        this.itemizedSummaryTableData = [];
        let query = firebase
          .firestore()
          .collection('times')
          .where('org', '==', sessionStorage.getItem('org'));
        if (this.searchCustomer != null && this.searchCustomer != '') {
          query = query.where(
            'customer',
            '==',
            this.searchCustomer.toLowerCase()
          );
        }
        if (this.searchJobNum != null && this.searchJobNum != '') {
          query = query.where('jobNum', '==', Number(this.searchJobNum.value));
        }
        if (this.searchStartDate != null && this.searchStartDate != '') {
          query = query.where('date', '>=', this.searchStartDate);
        }
        if (this.searchEndDate != null && this.searchEndDate != '') {
          query = query.where(
            'date',
            '<=',
            new Date(moment(this.searchEndDate).endOf('day'))
          );
        }

        await query
          .orderBy('date', 'asc')
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.empty) {
              console.log('No records returned.');
            }
            let currentDate;
            querySnapshot.forEach((doc) => {
              let newTime = {
                id: doc.id,
                approved: doc.data().approved,
                approvedBy: doc.data().approvedBy,
                approvedTime: doc.data().approvedTime,
                JobNum: `${doc.data().jobNum}`,
                Customer: doc.data().customer,
                Date: moment(doc.data().date.toDate()).format('MMM DD, YY'),
                Employee: doc.data().employee,
                Description: doc.data().description,
                Billable: doc.data().billable ? false : true,
                Hours: doc.data().hours,
                Type: doc.data().overtime
                  ? 'ot'
                  : doc.data().travelTime
                  ? 'tt'
                  : 'reg',
                Rate: doc.data().rate,
                lineTotal: (
                  Number(doc.data().hours) * Number(doc.data().rate)
                ).toFixed(2),
              };

              this.tableData.push(newTime);
              this.altTableData.push(newTime);

              if (
                currentDate !=
                moment(doc.data().date.toDate()).format('MMM DD, YY')
              ) {
                this.reportTotals[1].value = (
                  Number(this.reportTotals[1].value) + 1
                ).toString();
                hoursWorkedDays.categories.push(
                  moment(doc.data().date.toDate()).format('MMM DD, YY')
                );
                hoursWorkedData[0].data.push(Number(doc.data().hours));
              } else {
                hoursWorkedData[0].data[hoursWorkedData[0].data.length - 1] =
                  hoursWorkedData[0].data[hoursWorkedData[0].data.length - 1] +
                  Number(doc.data().hours);
              }

              //start adding name to the labels for the pie chart.
              if (!hoursWorkedEmployeeNames.includes(doc.data().employee)) {
                hoursWorkedEmployeeNames.push(doc.data().employee);
                hoursWorkedEmployeeData.push(0);
              }

              currentDate = moment(doc.data().date.toDate()).format(
                'MMM DD, YY'
              );
              this.reportTotals[0].value = (
                Number(this.reportTotals[0].value) + Number(doc.data().hours)
              )
                .toFixed(2)
                .toString();

              //add the hours for the employee.
              let valIndex = hoursWorkedEmployeeNames.indexOf(
                doc.data().employee
              );
              hoursWorkedEmployeeData[valIndex] =
                hoursWorkedEmployeeData[valIndex] + Number(doc.data().hours);

              //Create the hours table data for the all employees summary table
              // value is the sum of all hours/products, total is the sum of the hours/products multiplied by the rate
              let regularHours = { value: 0, total: 0 };
              let overtimeHours = { value: 0, total: 0 };
              let travelHours = { value: 0, total: 0 };

              if (doc.data().overtime) {
                overtimeHours = {
                  value: Number(doc.data().hours),
                  total: Number(doc.data().hours) * Number(doc.data().rate),
                };
              } else if (doc.data().travelTime) {
                travelHours = {
                  value: Number(doc.data().hours),
                  total: Number(doc.data().hours) * Number(doc.data().rate),
                };
              } else {
                regularHours = {
                  value: Number(doc.data().hours),
                  total: Number(doc.data().hours) * Number(doc.data().rate),
                };
              }
              let index = this.summaryTableData.findIndex(
                (x) => x.id === doc.data().user
              );
              //if the user already has an object, just add the total for the time to that object
              if (index !== -1) {
                this.summaryTableData[index].regularHours.value +=
                  regularHours.value;
                this.summaryTableData[index].overtimeHours.value +=
                  overtimeHours.value;
                this.summaryTableData[index].travelHours.value +=
                  travelHours.value;
                this.summaryTableData[index].regularHours.total +=
                  regularHours.total;
                this.summaryTableData[index].overtimeHours.total +=
                  overtimeHours.total;
                this.summaryTableData[index].travelHours.total +=
                  travelHours.total;
              } else {
                //create an object for that user with the totals
                this.summaryTableData.push({
                  name: doc.data().employee,
                  id: doc.data().user,
                  regularHours: regularHours,
                  overtimeHours: overtimeHours,
                  travelHours: travelHours,
                });
              }
            });

            if (this.selectedTimeApprovalFilter === 'unapproved') {
              this.tableData = this.tableData.filter(item => !item.approved);
            } else if (this.selectedTimeApprovalFilter === 'approved') {
              this.tableData = this.tableData.filter(item => item.approved);
            }

            //set the chart data.
            this.hoursByDays.series = hoursWorkedData;
            this.hoursByEmployee.series = hoursWorkedEmployeeData;
            //this ... notation takes all of the data that is in the object and we can just set one specific nessted object within it. Like so... (get it... ha!)
            this.hoursByDays.chartOptions = {
              ...this.hoursByDays.chartOptions,
              ...{
                xaxis: hoursWorkedDays,
              },
            };
            this.hoursByEmployee.chartOptions = {
              ...this.hoursByEmployee.chartOptions,
              ...{
                labels: hoursWorkedEmployeeNames,
              },
            };
            //this.hoursByEmployee.chartOptions.labels = hoursWorkedEmployeeNames;
          })
          .then(async () => {
            //get the products for the all employees summary table
            let query = firebase
              .firestore()
              .collection('billableProducts')
              .where('org', '==', sessionStorage.getItem('org'));
            if (this.searchCustomer !== null && this.searchCustomer !== '') {
              query = query.where(
                'customer',
                '==',
                this.searchCustomer.toLowerCase()
              );
            }
            if (this.searchJobNum !== null && this.searchJobNum !== '') {
              query = query.where('jobNum', '==', Number(this.searchJobNum.value));
            }
            if (this.searchStartDate !== null && this.searchStartDate !== '') {
              query = query.where('date', '>=', this.searchStartDate);
            }
            if (this.searchEndDate !== null && this.searchEndDate !== '') {
              query = query.where(
                'date',
                '<=',
                new Date(moment(this.searchEndDate).endOf('day'))
              );
            }
            await query
              .orderBy('date', 'asc')
              .get()
              .then((querySnapshot) => {
                if (querySnapshot.empty) {
                  console.log('No records returned.');
                }
                querySnapshot.forEach((doc) => {
                  let index = this.summaryTableData.findIndex(
                    (x) => x.id === doc.data().user.uid
                  );
                  if (index !== -1) {
                    //if the user already has an object
                    if (
                      this.summaryTableData[index][doc.data().products] !==
                      undefined
                    ) {
                      //if the product is already present on the users object, just add to it
                      this.summaryTableData[index][doc.data().products].value +=
                        Number(doc.data().quantity);
                      this.summaryTableData[index][doc.data().products].total +=
                        Number(doc.data().quantity) * Number(doc.data().rate);
                    } else {
                      //add the product to every users object set to 0 and then set the appropriate user object to the quantity

                      this.summaryTableData.forEach((data, index) => {
                        this.summaryTableData[index][doc.data().products] = {
                          value: 0,
                          total: 0,
                        };
                      });
                      this.productsInTable.push(doc.data().products);
                      this.summaryTableData[index][doc.data().products].value =
                        Number(doc.data().quantity);
                      this.summaryTableData[index][doc.data().products].total =
                        Number(doc.data().quantity) * Number(doc.data().rate);
                      this.fieldsSummary.push({
                        key: `${doc.data().products}.value`,
                        label: doc.data().products,
                        sortable: true,
                      });
                    }
                  } else {
                    //if the user does not already have an object, create one for them
                    let newIndex = this.summaryTableData.push({
                      name: doc.data().user.name,
                      id: doc.data().user.uid,
                      regularHours: 0,
                      overtimeHours: 0,
                      travelHours: 0,
                    });
                    if (
                      this.summaryTableData[0][doc.data().products] ===
                      undefined
                    ) {
                      //if this product is not added to the rest of the objects yet, add it to all of them
                      this.summaryTableData.forEach((data, index) => {
                        this.summaryTableData[index][doc.data().products] = {
                          value: 0,
                          total: 0,
                        };
                      });
                      this.productsInTable.push(doc.data().products);
                    }
                    //add any missing fields to the newly added object
                    this.productsInTable.forEach((product) => {
                      this.summaryTableData[newIndex - 1][product] = {
                        value: 0,
                        total: 0,
                      };
                    });
                    //set the appropriate field to the quantity
                    this.summaryTableData[newIndex - 1][doc.data().products] = {
                      value: Number(doc.data().quantity),
                      total:
                        Number(doc.data().quantity) * Number(doc.data().rate),
                    };
                    this.fieldsSummary.push({
                      key: `${doc.data().products}.value`,
                      label: doc.data().products,
                      sortable: true,
                    });
                  }
                });
              });
          })
          .catch((err) => {
            console.log(err);
            Vue.$toast.open({
              message: `Error generating report. Please contact support.`,
              duration: 8000000,
              position: 'top-right',
              dismissible: true,
              type: 'error',
            });
          });
        this.reportTotals[2].value = (
          Number(this.reportTotals[0].value) /
          Number(this.reportTotals[1].value)
        )
          .toFixed(2)
          .toString();

        this.createItemizedSummaryTable();
      } catch (err) {
        console.log(`Error getting job data: ${err}`);
      } finally{
        this.loading = false
      }
    },
    createItemizedSummaryTable() {
      for (let i = 0; i < this.summaryTableData.length; i++) {
        Object.keys(this.summaryTableData[i]).map((key) => {
          if (this.summaryTableData[i][key].value > 0) {
            let data = {
              employeeName: this.summaryTableData[i].name,
              employeeID: this.summaryTableData[i].id,
            };
            data['valueData'] = this.summaryTableData[i][key];
            data['valueName'] = key;
            this.itemizedSummaryTableData.push(data);
          }
        });
      }
    },
    getInitialCustomers() {
      getCustomers()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.customers.push(doc.data().displayName);
          });
        })
        .catch(() => {
          console.log(`Error getting customers...`);
        });
    },
    setTableSettings: function () {
      this.currentUser = this.$store.state.custom.currentUserData;
      if (this.currentUser.tablePageLengths) {
        if (this.currentUser.tablePageLengths.perPage_hoursWorkedTimes) {
          this.perPage =
            this.currentUser.tablePageLengths.perPage_hoursWorkedTimes;
        }
        if (this.currentUser.tablePageLengths.perPage_hoursWorkedSummary) {
          this.perPageSummary =
            this.currentUser.tablePageLengths.perPage_hoursWorkedSummary;
        }
      }
    },
    getJobs() {
      this.jobs = [];
      getJobsFromCustomer(this.searchCustomer)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const jobData = doc.data();
            this.jobs.push({ value: jobData.jobNum, label: `${jobData.jobNum} - ${jobData.description}`});
          });
        })
        .catch((err) => {
          console.log(`Error getting job numbers from customer.`);
          console.log(err);
        });
    },
    getJobNumFromString(timeData){
      const jobString = timeData;
      let wordArray = jobString.split(" ");
      return wordArray[0];
    },
    updateJobCompleteStatus(jobDocID, jobCompleteStatus){
      //update the complete status of the job.
      try {
        firebase
          .firestore()
            .collection('jobs')
            .doc(jobDocID)
            .update({
              completed: !jobCompleteStatus,
            })
            .then(() => {
              // update local data
              let tableDataCopy = lodash.cloneDeep(this.tableData);
              // filter so we only have times associated with this specific jobDocID
              let jobTimes = tableDataCopy.filter((time) => time.JobDocID === jobDocID);
              jobTimes.forEach((time) => {
                time.JobCompletedStatus = !jobCompleteStatus;
              });
              // because jobTimes filtered times array references tableDataCopy, we can just update this.tableData with tableDataCopy
              this.tableData = tableDataCopy;
              Vue.$toast.open({
                message: 'Job status updated',
                type: 'success',
                duration: 4000,
                position: 'top-right',
              });
            })
            .catch(() => {
              Swal.fire(
                'Error!',
                'Error updating the completed status of the job. (1)',
                'error'
              );
            });
      } catch (err) {
        Swal.fire(
          'Error!',
          'Error updating the completed status of the job. (2)',
          'error'
        );
      }
    },
    goToJob(jobNum){
      // pull the job number from the "job num - job description" string and push user to the job route
      this.$router.push(`/production/jobs/jobDetails/${this.getJobNumFromString(jobNum)}`);
    },
    tableSort: tableSort,
  },
  created: function () {
    this.getInitialCustomers();
    this.setTableSettings();
  },
};
</script>
